import { HISTORY_DB_KEY } from "@reco/service/src/constants";
import { ProductVisitRecord } from "@reco/service/src/types/records";

export function getCookieValue(name: string): string | undefined {
  if (typeof document === "undefined" || !document.cookie) return undefined;

  for (const part of document.cookie.split(";")) {
    const cookie = part.trim();
    if (!cookie.startsWith(`${name}=`)) continue;

    const encodedValue = cookie.slice(name.length + 1);
    if (!encodedValue) return undefined;

    try {
      return decodeURIComponent(encodedValue);
    } catch (err) {
      console.error(`[getCookieValue] Failed to decode "${name}":`, err);
      return undefined;
    }
  }
  return undefined;
}

export function getVisitHistory(): ProductVisitRecord[] {
  try {
    const storedData = localStorage.getItem(HISTORY_DB_KEY);
    return JSON.parse(storedData || "[]");
  } catch (error) {
    console.error("[getVisitHistory] Failed to parse recommendations from local storage:", error);
    clearVisitHistory();
    return [];
  }
}

export function clearVisitHistory() {
  if (typeof localStorage === "undefined") {
    return;
  }
  localStorage.removeItem(HISTORY_DB_KEY);
}
